import { useEffect } from 'react';
import PropTypes from 'prop-types';
import lottie from 'lottie-web';
import loader from 'assets/vehicle-loader.json';

function LoadingAnimation({ visible, animationID }) {
	useEffect(() => {
		let animation;
		if (visible) {
			animation = lottie.loadAnimation({
				container: document.getElementById(animationID),
				animationData: loader,
				renderer: 'svg',
				loop: true,
				autoplay: true,
			});
		}
		return () => {
			animation.destroy();
		};
	}, [visible, animationID]);

	return <div id={animationID} style={{ display: visible ? 'block' : 'none' }} />;
}

LoadingAnimation.propTypes = {
	visible: PropTypes.bool,
	animationID: PropTypes.string,
};

export default LoadingAnimation;
